import { operatorClient } from 'domain/HttpClients';

export const fetch = () => operatorClient.Get('/api/ops/get-default-currency').send();
